import { render } from "./MicroNews.vue?vue&type=template&id=7a8d7368&scoped=true"
import script from "./MicroNews.vue?vue&type=script&lang=js"
export * from "./MicroNews.vue?vue&type=script&lang=js"

import "./MicroNews.vue?vue&type=style&index=0&id=7a8d7368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8d7368"]])

export default __exports__